import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import firebase from 'firebase';
let provider = new firebase.auth.GoogleAuthProvider();

// Initialize Firebase
var config = {
    apiKey: "AIzaSyA6yPp4psYTwoYh1T22rOVKMH3lA9djTSo",
    authDomain: "wantlist-manager-a2841.firebaseapp.com",
    databaseURL: "https://wantlist-manager-a2841.firebaseio.com",
    projectId: "wantlist-manager-a2841",
    storageBucket: "wantlist-manager-a2841.appspot.com",
    messagingSenderId: "398620377128"
};
firebase.initializeApp(config);

let user = firebase.auth().currentUser;
if(user) {
    console.log(user);
}
else {
    firebase.auth().signInWithRedirect(provider);
}

firebase.auth().getRedirectResult().then(function(result) {
    if (result.credential) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      alert('Conected : ' + token);
      // ...
    }
    // The signed-in user info.
    var user = result.user;
  }).catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    // ...
  });

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js